module.exports = __webpack_public_path__ + "img/avatar-100.80a0688a.jpg";